module.exports = __webpack_public_path__ + "img/tv_console.06f31910.png";